import React, { useState } from 'react'
import IconHelper, { Direction } from '@ringdna/common/src/assets/icons/IconHelper'
import RdnaButton from '@ringdna/common/src/components/RdnaButton'
import { Colors } from '@ringdna/common/src/constants/colors'
import Arrow from '@ringdna/common/src/assets/icons/svg/Arrow'
import styled from 'styled-components'
import ExportModal from './ExportModal'
import { UserStatus } from '../utils'

export type Props = {
  accountId: string
  globalFilter?: string
  userStatus?: UserStatus
}

export default function ExportUsersButton(data: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const DownloadIcon = () => {
    return (
      <IconHelper icon={Arrow} direction={Direction.DOWN} color={Colors.N100} variant={'outlined'} shape={'circle'} />
    )
  }
  return (
    <Container>
      <RdnaButton
        type="button"
        text="Download"
        color={'neutral'}
        variant="text"
        onClick={() => setIsOpen(!isOpen)}
        Icon={DownloadIcon}
      />
      <ExportModal data={data} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: end;
  padding-top: ${props => props.theme.spacing * 2}px;
`
